module.exports = function () {
	$('.site-search__pagination__trigger').click(function (e) {
		e.preventDefault();

		if (!$(this).attr('disabled')) {
			var targetPage = $(this).data('page');
			window.page = targetPage;

			Innophos.Pages.SearchPage.InsertResults();
		}
	});
};
